function getPointAtLength(element, length) {
  if (element == null || length == null) {
    return {
      x: 0,
      y: 0
    };
  }

  return element.getPointAtLength(length);
}

export { getPointAtLength };
